import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '@crowdctrl/shared';

type LeaseResponse = { acquired?: boolean; renewed?: boolean; released?: boolean };

@Injectable({
  providedIn: 'root',
})
export class MyOrdersLeaseService {
  private apiService = inject(ApiService);
  private baseUrl = '';

  setBaseUrl(url: string): void {
    this.baseUrl = url;
  }

  async acquireMyOrdersLease(
    workspaceId: string,
    sessionId: string,
    userId: string,
    holderId: string,
  ): Promise<boolean> {
    const res = await firstValueFrom(
      await this.apiService.post<
        LeaseResponse,
        { action: string; holderId: string; workspaceId: string }
      >(
        this.baseUrl,
        `/workspace_sessions_api/api/workspace-sessions/${sessionId}/responders/${userId}/my-orders-lease`,
        { action: 'acquire', holderId, workspaceId },
      ),
    );
    return res?.acquired ?? false;
  }

  async renewMyOrdersLease(
    workspaceId: string,
    sessionId: string,
    userId: string,
    holderId: string,
  ): Promise<boolean> {
    const res = await firstValueFrom(
      await this.apiService.post<
        LeaseResponse,
        { action: string; holderId: string; workspaceId: string }
      >(
        this.baseUrl,
        `/workspace_sessions_api/api/workspace-sessions/${sessionId}/responders/${userId}/my-orders-lease`,
        { action: 'renew', holderId, workspaceId },
      ),
    );
    return res?.renewed ?? false;
  }

  async releaseMyOrdersLease(
    workspaceId: string,
    sessionId: string,
    userId: string,
    holderId: string,
  ): Promise<void> {
    await firstValueFrom(
      await this.apiService.post<
        LeaseResponse,
        { action: string; holderId: string; workspaceId: string }
      >(
        this.baseUrl,
        `/workspace_sessions_api/api/workspace-sessions/${sessionId}/responders/${userId}/my-orders-lease`,
        { action: 'release', holderId, workspaceId },
      ),
    );
  }
}
